<template>
    <div class="container">
        <div class="row mt-5">
            <div class="col-12 col-md-8">
                <h4>{{ $lang('Dodatkowe powiadomienia mailowe dla konsultanta (DW)') }}</h4>
                <table class="table simple-table table-striped table-sm" v-if="e_mailing_consultants.length > 0">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">{{ $lang('Konsultant') }}</th>
                        <th scope="col">{{ $lang('Podjęcie zgłoszenia') }}</th>
                        <th scope="col">{{ $lang('Dalsza obsługa zgłoszenia') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="person in e_mailing_consultants">
                        <td :data-title="$lang('Osoba')">{{ person.surname + " " + person.name }}</td>
                        <td :data-title="$lang('Podjęcie zgłoszenia')">
                            <input type="checkbox" :id="'create_task_consultant_' + person.id" :name="'create_task_consultant_' + person.id"
                                   :checked="person.create_task"
                                   @change="changeCreateTaskConsultant(person.id, $event)">
                            <label :for="'create_task_consultant_' + person.id">{{ $lang('Wysyłka') }}</label>
                        </td>
                        <td :data-title="$lang('Dalsza obsługa zgłoszenia')">
                            <input type="checkbox" :id="'processing_task_consultant_' + person.id"
                                   :name="'processing_task_consultant_' + person.id"
                                   :checked="person.processing_task"
                                   @change="changeProcessingTaskConsultant(person.id, $event)">
                            <label :for="'processing_task_consultant_' + person.id">{{ $lang('Wysyłka') }}</label>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p v-else>{{ $lang('Brak konsultantów') }}</p>
            </div>
            <div class="col-12 col-md-4 mt-3">
                <div class="alert alert-primary" role="alert">
                    <p>{{$lang('Dostępne typy powiadomień (konsultant):')}}</p>
                    <ul>
                        <li v-for="type in typesConsultant">{{type}}</li>
                    </ul>
                </div>
            </div>
            <div class="col-12"><hr></div>
            <div class="col-12">
                <h4>{{ $lang('Adresat wiadomości dla klienta') }}</h4>
                <div>
                    <input type="radio" name="customer_addressee" :value="0" id="customer_addressee"
                           v-model="addressee_type">
                    <label  for="customer_addressee"><span class="mr-3">{{ $lang('Osoba zgłaszająca') }}</span></label>
                    <input type="radio" name="customer_addressee" :value="1" id="customer_addressee"
                           v-model="addressee_type">
                    <label  for="customer_addressee"><span>{{ $lang('Stały adres e-mail') }}</span></label>
                </div>
                <div class="mt-3" v-if="addressee_type===1">
                    <label  for="addressee_mail"><span>{{ $lang('Adres e-mail') }}</span></label>
                    <input type="text" class="form-control w-100" name="addressee_mail" id="addressee_mail" v-model="addressee_mail"></input>
                    <validation-errors :errors="validationErrors" :field="'notification_address'"></validation-errors>
                </div>
            </div>
            <div class="col-12 col-md-8 mt-5">
                <h4>{{ $lang('Dodatkowe powiadomienia mailowe dla klienta (DW)') }}</h4>
                <table class="table simple-table table-striped table-sm" v-if="e_mailing_customers.length > 0">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">{{ $lang('Klient') }}</th>
                        <th scope="col">{{ $lang('Utworzenie zgłoszenia') }}</th>
                        <th scope="col">{{ $lang('Dalsza obsługa zgłoszenia') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="person in e_mailing_customers">
                        <td :data-title="$lang('Osoba')">{{ person.surname + " " + person.name }}</td>
                        <td :data-title="$lang('Utworzenie zgłoszenia')">
                            <input type="checkbox" :id="'create_task_customer_' + person.id" :name="'create_task_customer_' + person.id"
                                   :checked="person.create_task"
                                   @change="changeCreateTaskCustomer(person.id, $event)">
                            <label :for="'create_task_customer_' + person.id">{{ $lang('Wysyłka') }}</label>
                        </td>
                        <td :data-title="$lang('Dalsza obsługa zgłoszenia')">
                            <input type="checkbox" :id="'processing_task_customer_' + person.id"
                                   :name="'processing_task_customer_' + person.id"
                                   :checked="person.processing_task"
                                   @change="changeProcessingTaskCustomer(person.id, $event)">
                            <label :for="'processing_task_customer_' + person.id">{{ $lang('Wysyłka') }}</label>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p v-else>{{ $lang('Brak klientów') }}</p>
            </div>
            <div class="col-12 col-md-4 mt-5">
                <div class="alert alert-primary" role="alert">
                    <p>{{$lang('Dostępne typy powiadomień (klient):')}}</p>
                    <ul>
                        <li v-for="type in typesCustomer">{{type}}</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 mt-5">
                <button id="config-save" @click.prevent="save()" type="button" class="btn btn-primary pull-right">
                    {{ $lang('Zapisz') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "library-mailing-list",
    mixins: [ShowNotification],
    props: {
        mailingConsultants: {
            type: Array
        },
        mailingCustomers: {
            type: Array
        },
        typesConsultant: {
            type: Array
        },
        typesCustomer: {
            type: Array
        },
        customerCommonMail: {
            type: String,
            required: false
        },
        saveUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            e_mailing_consultants: [],
            e_mailing_customers: [],
            addressee_type: 0,
            addressee_mail: '',
            validationErrors: []
        }
    },
    methods: {
        save() {
            let self = this;
            self.validationErrors = [];
            axios.post(this.saveUrl, {
                     mailing_consultants: this.e_mailing_consultants,
                     mailing_customers: this.e_mailing_customers,
                     notification_address: this.addressee_type === 1 ? this.addressee_mail : null,
                     address_type: this.addressee_type
                 })
                 .then(function (response) {
                     self.showNotification('success', self.$lang('Zapisano!'));
                 })
                 .catch((error) => {
                     if (error.response.status === 422) {
                         self.validationErrors = error.response.data.errors;
                     }
                     self.showNotification('error', self.$lang('Wystąpił błąd przy zapisie!'));
                     console.log(error);
                 });
        },
        changeCreateTaskConsultant(id, e) {
            this.e_mailing_consultants.map(function (person) {
                if (person.id === id) {
                    person.create_task = Boolean(e.target.checked);
                }
                return person;
            })
        },
        changeProcessingTaskConsultant(id, e) {
            this.e_mailing_consultants.map(function (person) {
                if (person.id === id) {
                    person.processing_task = Boolean(e.target.checked);
                }
                return person;
            })
        },
        changeCreateTaskCustomer(id, e) {
            this.e_mailing_customers.map(function (person) {
                if (person.id === id) {
                    person.create_task = Boolean(e.target.checked);
                }
                return person;
            })
        },
        changeProcessingTaskCustomer(id, e) {
            this.e_mailing_customers.map(function (person) {
                if (person.id === id) {
                    person.processing_task = Boolean(e.target.checked);
                }
                return person;
            })
        },
    },
    created() {
        this.e_mailing_consultants = this.mailingConsultants;
        this.e_mailing_customers = this.mailingCustomers;

        if (this.customerCommonMail) {
            this.addressee_type = 1;
            this.addressee_mail = this.customerCommonMail;
        } else {
            this.addressee_type = 0;
        }
    }
}
</script>
